<template>
  <div class="header-wrap">
    <div class="header-btns">
      <button class="header-btn" @click="$router.push('/Member/List')">
        회원현황
      </button>
      <button class="header-btn" @click="$router.push('/Transaction/List')">
        충환전내역
      </button>
      <button class="header-btn" @click="$router.push('/Race/History')">
        배팅내역
      </button>
      <button class="header-btn" @click="$router.push('/Calc/Period')">
        정산내역
      </button>
      <button class="header-btn" @click="logout">로그아웃</button>
    </div>
    <div class="race-info">
      <span v-if="!noNextGame && !nextGameLoading">
        <span>
          <img :src="countryImg" alt="" />
          {{ nextRaceInfo.type }} {{ nextRaceInfo.location }}
          {{ nextRaceInfo.round }}R {{ nextRaceInfo.distance }}M
        </span>
        <span class="race-time">
          {{ $moment(nextRaceInfo.start_datetime).format("HH:mm") }}
        </span>
        <span>({{ raceTime }})</span>
      </span>
      <span class="race-done-text" v-else-if="noNextGame && nextGameLoading"
        >다음경기 일정이 없습니다.</span
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nextRaceInfo: {},
      countryImg: "",
      raceTime: "",
      nextGameLoading: true,
      noNextGame: false,
    };
  },
  mounted() {
    this.getRaceInfo();
  },
  methods: {
    getRaceInfo() {
      if (this.$store.state.isAuthenticated) {
        this.nextGameLoading = true;
        this.$axios
          .get("/race/next")
          .then((res) => {
            if (res) {
              if (res.data == "" || !res) {
                return (this.noNextGame = true);
              }
              this.nextRaceInfo = res.data;
            }
            this.countryImgCg();
            this.timeCount();
            setInterval(this.timeCount, 1000);
          })
          .finally(() => {
            this.nextGameLoading = false;
          });
      }
    },
    //로그아웃
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
        this.$notify({
          type: "success",
          text: "로그아웃 처리되었습니다.\n이용해 주셔서 감사합니다.",
        });
      });
    },
    // 국가별 국기
    countryImgCg() {
      let country = this.nextRaceInfo.country;
      switch (country) {
        case "일본":
          this.countryImg = "/images/jp.png";
          break;
        case "호주":
          this.countryImg = "/images/au.png";
          break;
        case "한국":
          this.countryImg = "/images/ko.png";
          break;
      }
    },
    // 다음 게임까지 남은시간
    timeCount() {
      let startTime = this.nextRaceInfo.start_datetime;
      let current = this.$moment()
        .utc()
        .add(9, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      let diff = this.$moment(startTime).diff(current, "second");
      this.raceTime = this.$moment()
        .startOf("day")
        .second(diff)
        .format("HH:mm:ss");
      if (this.raceTime == "00:00:00") {
        this.getRaceInfo();
      }
    },
  },
};
</script>
